module.exports = __webpack_public_path__ + "img/icon_5_99.22f18954.png";